import React, { useEffect } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../redux/store/Store";
import { InActiveCorporatePatientList } from "../../../../redux/interfaces/Model";
import * as _ from "lodash";
import { getInactiveCorporatePatinetList } from "../../../../redux/effects/ApiCall";
import { CorporatePackageList } from "../../../../redux/CorporatePackage/Package/Model";
import { getCorporatePackageList } from "../../../../redux/CorporatePackage/Package/ApiCall";
import { getPatientList } from "../../../../redux/CorporatePackage/PatientTeam/PatientList/ApiCall";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import MWExceptionList from "../../../../component/MWExceptionList";
import { t } from "i18next";
export default function InActivePatientListUnderPatientTeam(props: any) {
  const { inActivePatientListUnderPatientTeamLoader } = props;
  const { packageId } = useParams() as {
    packageId: string;
  };
  const { profileId } = useParams() as {
    profileId: string;
  };

  const dispatch = useDispatch();

  const history = useHistory();

  const DATE_OPTIONS = {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  } as const;
  function gotoDetails(patientId: number) {
    history.push(`/patientdetails/${patientId}`);
  }

  const truncate = (str: String) => {
    return str.length > 20 ? str.substring(0, 25) + "..." : str;
  };

  //call Inactive Patient List Store
  const inActiveCorporatePatientList = useSelector(
    (state: AppState) => state.inactiveCorporatePatientValue
  );
  const inActiveCorporatePatientListValues: InActiveCorporatePatientList =
    _.filter(inActiveCorporatePatientList.inActiveCorporatePatientListValue, [
      "profileId",
      Number(profileId),
    ])[0];

  // call Inactive Package List Store

  const inActiveCorporatePackageList = useSelector(
    (state: AppState) => state.corporatePackageValue
  );
  const inActiveCorporateListDetails: CorporatePackageList = _.filter(
    inActiveCorporatePackageList.corporatePackageListValue,
    ["id", Number(packageId)]
  )[0];

  // call Patient list Store
  const patientListLoadingValue = useSelector(
    (state: AppState) => state.patientTeamPatientListvalue.loading
  );
  const patientList = useSelector(
    (state: AppState) => state.patientTeamPatientListvalue.patientListValue
  );

  // corporate package body
  const corporatePackageBody = {
    active: Number(0),
  };

  // reload patient list API
  const getPatientListByPatientTeam = () => {
    dispatch(getPatientList(profileId));
  };

  useEffect(() => {
    dispatch(getPatientList(profileId));
    if (
      inActiveCorporateListDetails === undefined &&
      inActiveCorporateListDetails === undefined
    ) {
      dispatch(getCorporatePackageList(corporatePackageBody));
      dispatch(getInactiveCorporatePatinetList(packageId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    inActiveCorporateListDetails,
    inActiveCorporatePatientListValues,
  ]);

  let patientListConfig = [];
  for (var i = 0; i < patientList.length; i++) {
    let patientId: number = patientList[i].id;
    let firstname =
      patientList[i].firstname === "" || patientList[i].firstname === null
        ? " "
        : patientList[i].firstname;
    let lastname =
      patientList[i].lastname === "" || patientList[i].lastname === null
        ? " "
        : patientList[i].lastname;
    let dob =
      patientList[i].dob === "" || patientList[i].dob === null
        ? " "
        : new Date(patientList[i].dob).toLocaleDateString(
            "en-US",
            DATE_OPTIONS
          );
    let patientRelationshipWithOwner =
      patientList[i].patientRelationshipWithOwner?.displayValue;
    let gender = patientList[i].gender?.label;
    let bloodGroup = patientList[i].bloodGroup?.label;
    let description =
      patientList[i].description === "" || patientList[i].description === null
        ? " "
        : truncate(patientList[i].description);
    patientListConfig.push([
      // <Button icon={ViewMinor} size="slim" onClick={() => gotoDetails(patientId)}>View</Button>,
      <Button
        variant="outlined"
        onClick={() => gotoDetails(patientId)}
        startIcon={<VisibilityIcon />}
        sx={{ textTransform: "none" }}
      >
        {t("common.view", { ns: ["home"] })}
      </Button>,
      patientId,
      firstname,
      lastname,
      dob,
      patientRelationshipWithOwner,
      gender,
      bloodGroup,
      description,
    ]);
  }
  const patientListTableValue: any[] = patientListConfig;
  const actualPageMarkup = (
    <Card>
      <CardHeader title={t("common.patientDetails", { ns: ["home"] })}>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="flex-end"
        >
          <Grid item>
            <Button
              variant="outlined"
              startIcon={<RefreshIcon />}
              onClick={getPatientListByPatientTeam}
              sx={{ textTransform: "none" }}
            >
              {t("common.reload", { ns: ["home"] })}
            </Button>
          </Grid>
        </Grid>
      </CardHeader>
      <CardContent>
        {patientListTableValue && patientListTableValue.length ? (
          <TableContainer>
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("common.view", { ns: ["home"] })}</TableCell>
                  <TableCell>
                    {t("patientlistpage.userid", { ns: ["home"] })}
                  </TableCell>
                  <TableCell>
                    {t("patientlistpage.firstname", { ns: ["home"] })}
                  </TableCell>
                  <TableCell>
                    {t("patientlistpage.lastname", { ns: ["home"] })}
                  </TableCell>
                  <TableCell>
                    {t("patientlistpage.dob", { ns: ["home"] })}
                  </TableCell>
                  <TableCell>
                    {t("patientlistpage.relation", { ns: ["home"] })}
                  </TableCell>
                  <TableCell>
                    {t("patientlistpage.gender", { ns: ["home"] })}
                  </TableCell>
                  <TableCell>
                    {t("patientlistpage.bloodgrp", { ns: ["home"] })}
                  </TableCell>
                  <TableCell>
                    {t("patientlistpage.des", { ns: ["home"] })}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {patientListTableValue.map((row: any) => (
                  <TableRow
                    key={row.description}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell align="left">{row[0]}</TableCell>
                    <TableCell align="left">{row[1]}</TableCell>
                    <TableCell align="left">{row[2]}</TableCell>
                    <TableCell align="left">{row[3]}</TableCell>
                    <TableCell align="left">{row[4]}</TableCell>
                    <TableCell align="left">{row[5]}</TableCell>
                    <TableCell align="left">{row[6]}</TableCell>
                    <TableCell align="left">{row[7]}</TableCell>
                    <TableCell align="left">{row[8]}</TableCell>
                    <TableCell align="left">{row[9]}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <MWExceptionList />
        )}
      </CardContent>
    </Card>
  );
  return (
    <Box>
      {(inActiveCorporateListDetails === undefined &&
        inActiveCorporatePatientListValues === undefined) ||
      patientListLoadingValue === true
        ? inActivePatientListUnderPatientTeamLoader(true)
        : inActivePatientListUnderPatientTeamLoader(false)}
      <Container maxWidth="xl">{actualPageMarkup}</Container>
    </Box>
  );
}
